module.exports = __webpack_public_path__ + "static/media/operator.21eef1b3.jpg";